

















































import {Component, Vue} from "vue-property-decorator";
import PayrollService from "@/services/payroll/PayrollService";
import FileUpload from "@/components/common/FileUpload.vue";
import PayrollFileCategories from "@/constants/PayrollFileCategories";
import RouteNames from "@/router/RouteNames";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import {PayrollReport} from "@/components/payroll/business/employments/employee/PayrollReport";
import EmploymentService from "@/services/EmploymentService";
import {EmploymentFilter} from "@/dto/payroll/Filters";
import {EmploymentStatus} from "@/components/payroll/business/employments/contractors/Contractor";
import EmployeeDto from "@/dto/payroll/EmployeeDto";
import {processError} from "@/utils/ComponentUtils";
import {PayrollReportFilter} from "@/dto/payroll/PayrollReportFilter";
import CollapsedPaystubReport from "@/components/payroll/reports/paystub/CollapsedPaystubReport.vue";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import Application from "@/state/Application";
import PaystubReport from "@/components/payroll/reports/paystub/PaystubReport.vue";

@Component({
	components: {PaystubReport, PaginationComponent, CollapsedPaystubReport, PortalDate, PortalSelect, FileUpload}
})
export default class BusinessEmployeePaystubs extends Vue {

	private paystubs: Array<PayrollReport> = [];

	private employee: EmployeeDto | null = null;

	private filter = new PayrollReportFilter()

	private totalPages = 0;

	mounted() {
		if (!this.$route.params.personId) {
			this.$router.push({
				name: RouteNames.PAYROLL_BUSINESS_EMPLOYEES,
				params: {companyId: this.$route.params.companyId, then: PayrollFileCategories.PAYSTUB}
			});
		} else {
			Application.startLoading()
			this.loadPerson()
				.then(this.initFilter)
				.then(this.loadReports)
				.finally(Application.stopLoading)

		}
	}

	loadPerson() {
		return EmploymentService.getAllByFilter<EmployeeDto>(
			new EmploymentFilter(
				{
					detailsId: Number.parseInt(this.$route.params.personId, 10),
					employerId: Number.parseInt(this.$route.params.companyId, 10),
					types: ["STAFF"]
				}
			)
		).then(
			response => {
				this.employee = response.data[0];
			},
			err => processError(err, this)
		)
	}

	private resetFilter() {
		this.filter.startDate = null
		this.filter.endDate = null;
		this.filter.page = 0;
	}

	private initFilter() {
		this.filter.employeeId = this.employee!.details.id
		this.filter.employerId = this.employee!.employer.id
		this.filter.employmentId = this.employee!.id
		return Promise.resolve()
	}

	private loadReports(): Promise<void> {
		return PayrollService.getPaystubPageByFilter(this.filter).then(
			(response) => {
				this.paystubs = response.data.data;
				this.totalPages = response.data.countOfPages
			},
			err => processError(err, this)
		);
	}

}
